import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import RatingItemIcon from '../RatingItemIcon';

const RatingItemIcons = (props) => {
  const {
    substrateStyle = {},
    iconStyle = {},
    substrateClassName = '',
    iconClassName = '',
    onClick = noop,
    e2e = undefined,
    shape,
    enableFillColor,
    substrateIcon,
    icon,
  } = props;
  return (
    <React.Fragment>
      {enableFillColor && (
        <RatingItemIcon
          style={{ ...substrateStyle }}
          className={substrateClassName}
          shape={shape}
          icon={substrateIcon || icon}
          enableFillColor={enableFillColor}
        />
      )}
      <RatingItemIcon
        e2e={e2e}
        onClick={onClick}
        style={{ ...iconStyle }}
        className={iconClassName}
        shape={shape}
        icon={icon}
      />
    </React.Fragment>
  );
};

RatingItemIcons.propTypes = {
  substrateStyle: PropTypes.object.isRequired,
  iconStyle: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  substrateClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  e2e: PropTypes.any,
  shape: PropTypes.string.isRequired,
  enableFillColor: PropTypes.bool,
  substrateIcon: PropTypes.object,
  icon: PropTypes.object,
};

export default RatingItemIcons;
